import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

// Pages
import LandingPage from "@/pages/LandingPage";
import CustomerLogin from "@/pages/CustomerLogin";
import CustomerRegister from "@/pages/CustomerRegister";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ShopLogin from "@/pages/ShopLogin";
import ShopRegister from "@/pages/ShopRegister";
import ShopDashboard from "@/pages/ShopDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

// Auth context
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Protected route component
const ProtectedRoute = ({ children, userType }) => {
  const { user, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to={userType === 'shop' ? '/shop/login' : '/login'} replace />;
  }
  
  if (user.type !== userType) {
    return <Navigate to={user.type === 'shop' ? '/shop/dashboard' : '/dashboard'} replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<CustomerLogin />} />
            <Route path="/register" element={<CustomerRegister />} />
            <Route path="/shop/login" element={<ShopLogin />} />
            <Route path="/shop/register" element={<ShopRegister />} />
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* Customer protected routes */}
            <Route 
              path="/dashboard/*" 
              element={
                <ProtectedRoute userType="customer">
                  <CustomerDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Shop protected routes */}
            <Route 
              path="/shop/dashboard/*" 
              element={
                <ProtectedRoute userType="shop">
                  <ShopDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
